import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { BASE_URL } from './utils/config';
import { paths } from './routing/path';
import { isServerUnavailableError } from './utils/isServerUnavailableError';
import { maintenanceMode } from './utils/maintenanceMode';

declare module 'axios' {
    export interface AxiosRequestConfig<D = any> {
        // Set on requests (e.g. the maintenance health poll) whose failures
        // must not trigger the maintenance overlay.
        skipMaintenanceCheck?: boolean;
    }
}

export function createBaseAxiosInstance(): AxiosInstance {
    const instance = axios.create({
        baseURL: BASE_URL,
        withCredentials: true,
    });

    (instance as any).all = axios.all;
    (instance as any).spread = axios.spread;

    instance.interceptors.request.use(
        async (config: InternalAxiosRequestConfig) => {
            const token = localStorage.getItem('token');
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            const currentPracticeId = localStorage.getItem('currentPracticeId');
            if (currentPracticeId) {
                config.headers.practiceId = currentPracticeId;
            }
            const currentPracticeRegId = localStorage.getItem(
                'currentPracticeRegId'
            );
            if (currentPracticeRegId) {
                config.headers.practiceRegId = currentPracticeRegId;
            }
            return config;
        },
        (error) => {
            return error;
        }
    );

    instance.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (isServerUnavailableError(error)) {
                maintenanceMode.setServerUnavailable(true);
            }
            if (error.response && error.response.status === 401 &&
                !window.location.pathname.startsWith('/login')) {
                localStorage.clear();
                window.location.href = window.location.origin + paths.public.login;
            } else {
                return error;
            }
        }
    );

    return instance;
}
